module.exports = {"id":"204760","name":"Charlie Taylor","rating":"74","photo":"./data/images/photos/1/204760.png","club":{"name":"Burnley","logo":"./data/images/clubs/Burnley.png"},"positions":["DG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CharlieTaylor0.json
// module id = 765
// module chunks = 0